import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import { Shapes } from '../../models/entities';

class AchForm extends PureComponent {
  constructor(props) {
    super(props);

    const { ach } = props;
    if (ach) {
      this.state = { ...ach };
    } else {
      this.state = {
        alias: '',
        accountNumber: '',
        routingNumber: '',
        accountType: "Checking",
        active: true,
        bankName: '',
        contactInfo: {
          addressLine1: '', 
          addressLine2: '', 
          city: '', 
          countryCode: '', 
          email: '',
          id: '', 
          phoneNumber: '', 
          postalCode: '', 
          stateCode: '', 
          firstName: '', 
          lastName: '',
        },
        validated: false,
      };
    }
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateContactInfoState = this.updateContactInfoState.bind(this);
  }

  updateContactInfoState = (option, value) => {
    this.setState({
    contactInfo: {
      ...this.state.contactInfo,
      [option]: value
    }})
  }

  handleFieldChange = (event) => {
    switch (event.target.id) {
      case 'active': return (this.setState({ active: event.target.checked }));
      case 'alias': return (this.setState({ alias: event.target.value }));
      case 'accountNumber': return (this.setState({ accountNumber: event.target.value }));
      case 'routingNumber': return (this.setState({ routingNumber: event.target.value }));
      case 'bankName': return (this.setState({ bankName: event.target.value }));
      case 'firstName':return  this.updateContactInfoState('firstName', event.target.value);
      case 'lastName': return this.updateContactInfoState('lastName', event.target.value);
      case 'addressLine1':return  this.updateContactInfoState('addressLine1', event.target.value);
      case 'addressLine2': return this.updateContactInfoState('addressLine2', event.target.value);
      case 'phoneNumber': return this.updateContactInfoState('phoneNumber', event.target.value);
      case 'countryCode': return this.updateContactInfoState('countryCode', event.target.value);
      case 'city': return this.updateContactInfoState('city', event.target.value);
      case 'stateCode': return this.updateContactInfoState('stateCode', event.target.value);
      case 'postalCode': return this.updateContactInfoState('postalCode', event.target.value);
      case 'email': return this.updateContactInfoState('email', event.target.value);
      default: return this.state;
    }
  }

  handleSubmit = (event) => {
    const { onSubmit } = this.props;

    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === true) {

      let contact = {...this.state.contactInfo};
      if (contact.addressLine1 === '') contact.addressLine1 = "4836 E Indigo St #102";
      if (contact.city === '') contact.city = "Mesa";
      if (contact.stateCode === '') contact.stateCode = "AZ";
      if (contact.countryCode === '') contact.countryCode = "US";
      if (contact.phoneNumber === '') contact.phoneNumber = "4805906570";
      if (contact.postalCode === '') contact.postalCode = "85205";
      if (contact.email === '') contact.email = "sang.luu@allkiosk.com";
      const bankAccount = (({
        alias, accountType, accountNumber, routingNumber, bankName, active
      }) => ({
        alias, accountType, accountNumber, routingNumber, bankName, active
      }))(this.state);
      bankAccount.contactInfo = contact;
      const body = ({bankAccount});
      onSubmit(body);
    }
    this.setState({ validated: true });
  }

  render = () => {
    const {
      alias, accountNumber, routingNumber, active, bankName, validated, contactInfo
    } = this.state;

    const { formId, disabled } = this.props;

    return (
      <Form noValidate validated={validated} onSubmit={this.handleSubmit} id={formId}>
        <Form.Row>
          <Col>
            <Form.Group controlId="active">
              <Form.Check
                checked={active}
                type="checkbox"
                onChange={this.handleFieldChange}
                value={active}
                label="Is this bank account active?"
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="alias">
              <Form.Label>Alias</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={alias}
                placeholder="alias - nickname"
              />
              <Form.Control.Feedback type="invalid">
                Please provide a nickname for this bank account.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="accountNumber">
              <Form.Label>Account Number</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={accountNumber}
                placeholder="AccountNumber"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the account number.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="routingNumber">
              <Form.Label>Routing Number</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={routingNumber}
                placeholder="routingNumber"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the routing number.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="bankName">
              <Form.Label>Bank Name</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={bankName}
                placeholder="bankName"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the bank name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.firstName}
                placeholder="first name"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the first name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.lastName}
                placeholder="last name"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the last name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="phoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                disabled={disabled}
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.phoneNumber}
                placeholder="optional"
              />
              <Form.Control.Feedback type="invalid">
                Please provide a phone number.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="countryCode">
              <Form.Label>Country Code</Form.Label>
              <Form.Control
                disabled={disabled}
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.countryCode}
                placeholder="optional"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the country code.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="addressLine1">
              <Form.Label>Address Line1</Form.Label>
              <Form.Control
                disabled={disabled}
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.addressLine1}
                placeholder="optional"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the address line1.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="addressLine2">
              <Form.Label>Address Line2</Form.Label>
              <Form.Control
                disabled={disabled}
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.addressLine2 || '-'}
                placeholder="address line2"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the address line2.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="city">
              <Form.Label>City</Form.Label>
              <Form.Control
                disabled={disabled}
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.city}
                placeholder="optional"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the city.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="stateCode">
              <Form.Label>State Code</Form.Label>
              <Form.Control
                disabled={disabled}
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.stateCode}
                placeholder="optional"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the state code (abbreviation).
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="postalCode">
              <Form.Label>Postal Zip Code</Form.Label>
              <Form.Control
                disabled={disabled}
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.postalCode}
                placeholder="optional"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the zip code.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="email">
              <Form.Label>Contact Email</Form.Label>
              <Form.Control
                disabled={disabled}
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.email}
                placeholder="optional"
              />
              <Form.Control.Feedback type="invalid">
                Please provide an email address.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

AchForm.propTypes = {
  onSubmit: PropTypes.func,
  formId: PropTypes.string.isRequired,
  ach: Shapes.ACH,
  disabled: PropTypes.bool,
};

AchForm.defaultProps = {
  ach: null,
  onSubmit: undefined,
  disabled: false,
};

export default AchForm;
